import React from 'react';
import {Navigate, Outlet} from "react-router-dom";
import {getProject, getToken} from "../helpers/common";

export function PrivateRoute() {
    return (!!getToken() && !!getProject()) ? <Outlet /> : <Navigate to="/login" />;
};